class QuotationDetailViewController extends InvoiceDetailViewController
{
    static newInstance(): QuotationDetailViewController {
        let vc = new QuotationDetailViewController("quotation-detail-view");
        vc.initWithResource("layout/quotation_documents/QuotationDetailView.html");
        return vc;
    }

    // viewDidLoad(){
    //     super.viewDidLoad();

    //     this.editHeader = MUIOutlet(this, "edit-header-view", "QuotationDetailHeaderView");
    //     this.editHeader.setHidden(true);

    //     this.noEditHeader = MUIOutlet(this, "no-edit-header-view", "QuotationDetailHeaderView");
    //     this.noEditHeader.setHidden(false);
    // }
}
